// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"779":"08c56cf5","900":"66995459"}[chunkId] + ".chunk.css";
};